import util from '../util';

let controller = 'ACCS004Conciliacao';

export default {
    Listar: (dto, options) => {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller, dto)
    },
    SolicitarUploadArquivo: (dto) => {
        return util.Axios.Post(controller + '/uploads/solicitar', dto)
    },
    ConfirmarUpload: (id, situacao) => {
        return util.Axios.Put(controller, `uploads/${id}/confirmar?situacaoRequest=${situacao}`)
    },
    Cancelar: (id) => {
        return util.Axios.Put(controller, `${id}/Cancelar`)
    },
    DownloadArquivo: (id) => {
        return util.Axios.GetParams(controller + `/${id}/DownloadArquivo`)
    },
    DownloadRelatorio: (id) => {
        return util.Axios.GetParams(controller + `/${id}/DownloadRelatorio`)
    }
}
